export enum BoschUiButtonTypeEnum {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY',
  Integrated = 'INTEGRATED',
  Close = 'CLOSE',
}
